// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__RNraJ","bento":"Gallery_bento__1Uaop","tile":"Gallery_tile__Nwmbv","wide2x2":"Gallery_wide2x2__1PQ8G","wide2x1":"Gallery_wide2x1__HggJp"};